module.exports = __webpack_public_path__ + "static/media/dod-4.f84f1ca6.gif";